import $ from 'jquery';

let searchForm = $('.primary-menu .menu-search');

searchForm.on('click', function(e) {
    $(this).siblings().toggleClass('active');
});
